import clsx from 'clsx';
import { observer } from 'mobx-react-lite';
import { PropsWithChildren } from 'react';

import styles from './Info.module.scss';

type InfoProps = {
  className?: string;
  style?: React.CSSProperties;
} & PropsWithChildren;

export const Info = observer<InfoProps>(
  ({ className = '', style = {}, children }) => (
    <div
      className={clsx(
        styles.wrapper,
        'in-col-center in-text-center',
        className,
      )}
      style={style}
    >
      {children}
    </div>
  ),
);
